import createConditionCatalog from '@/helpers/createConditionCatalog';

export default createConditionCatalog([
  {
    name: 'connection',
    label: 'connection',
    value: null,
  },
  {
    name: 'not_connection',
    label: 'not connection',
    value: null,
  },
]);
